module.exports = __webpack_public_path__ + "img/8578e0e2-d2de-4e4f-92a9-7d6a0e359bc0.136b1c19.png";